(ns dashboard.views.workbook-workspace.components.common)

(defn close-icon [props]
  [:span (merge props
                {:style {:cursor "pointer"}}) "✕"])

(defn panel-top-bar [children]
  [:div.level.mb-0.p-1.level-items.has-background-secondary.workspace-topbar
   children])

(def sizer-button :button.button.is-small.has-text-weight-bold.ml-1.is-rounded.is-secondary)
